
import { ArrayMax } from "../Shared/Utility/ArrayUtilities";

export type TextCoverage = {
    minWidth: number;
    maxWidth: number;
    height: number;
    lineCount: number;
}

export type MeasureContext = {
    measure: CanvasRenderingContext2D;
    questionFontSize: number;
    answerMixedFontSize: number;
    answerTextFontSize: number;
    spaceWidthQuestion: number;
    spaceWidthAnswerText: number;
    spaceWidthAnswerMixed: number;
}

const QFONTSZ = 2.0;
const AMXSZ = 0.8;
const ATXTSZ = 1.0;


export type TextLayoutEngine = {
    getMinWidth: (fontSize: number, text: string) => number;
    getHeightsForColumns: (fontSize: number, minCols: number, maxCols: number, totalWidth: number, gutter: number, text: string) => number[];
    getFontSizeForHeight: (width: number, height: number, text: string) => number;
}

export const CreateTextLayoutEngine = (divId?: string, spanId?: string): TextLayoutEngine => {
    const measureContext = document.createElement("canvas").getContext("2d");

    const getMinWidth = (fontSize: number, text: string): number => {
        if (measureContext !== null) {
            measureContext.font = 'regular ' + fontSize + ' px Roboto';
            const words = text.split(' ');
            var maxWidth = 0;
            words.forEach((word) => {
                const ww = measureContext.measureText(word).width;
                maxWidth = Math.max(maxWidth, ww);
            });
            return maxWidth;
        }
        else
            return 500;


    }

    const getHeightForColumns = (fontSize: number, minCols: number, maxCols: number, totalWidth: number, gutter: number, text: string): number[] => {
        const divElement = divId === undefined ? null : document.getElementById(divId);
        const spanElement = spanId === undefined ? null : document.getElementById(spanId);

        const empty = divElement === null || spanElement === null;
        if (empty)
            return [];


        const widths = Array<number>();
        const ret = Array<number>();

        const minW = getMinWidth(fontSize, text);

        for (let i = minCols; i <= maxCols; i++) {
            const width = (totalWidth - (i - 1) * gutter) / i;
            if (width > minW)
                widths.push(width);
        }

        spanElement.innerHTML = text;
        divElement.style.fontSize = fontSize + 'px';


        widths.forEach((width, index) => {
            divElement.style.maxWidth = width + 'px';
            divElement.style.width = width + 'px';
            divElement.style.minWidth = width + 'px';

            var rect = divElement.getBoundingClientRect();
            ret.push(rect.height);

        });
        return ret;
    }

    const getFontSizeForHeight = (width: number, height: number, text: string): number => {

        const divElement = divId === undefined ? null : document.getElementById(divId);
        const spanElement = spanId === undefined ? null : document.getElementById(spanId);

        const empty = divElement === null || spanElement === null;
        if (empty)
            return 0;
        spanElement.innerHTML = text;
        /*divElement.style.removeProperty('minWidth');
        divElement.style.removeProperty('width');
        divElement.style.removeProperty('maxWidth');*/
        divElement.style.maxWidth = width + 'px';
            divElement.style.width = width + 'px';
            divElement.style.minWidth = width + 'px';
        const fontSizes = [8, 9, 10, 11, 12, 13, 14, 16, 18, 20, 22, 24, 28, 32, 36, 40, 44, 48, 52, 60, 72, 90, 120];


        var minIndex = 0;
        divElement.style.fontSize = fontSizes[minIndex] + 'px';
        var rect = divElement.getBoundingClientRect();
        var minHeight = rect.height;

        var maxIndex = fontSizes.length - 1;
        divElement.style.fontSize = fontSizes[maxIndex] + 'px';
        rect = divElement.getBoundingClientRect();
        var maxHeight = rect.height;

        if (minHeight > height)
            return fontSizes[0];
        else if (maxHeight < height)
            return fontSizes[maxIndex];

        var midIndex = Math.round((maxIndex + minIndex) * 0.5 + 0.5);
        divElement.style.fontSize = fontSizes[midIndex] + 'px';
        rect = divElement.getBoundingClientRect();
        var midHeight = rect.height;

        while (maxIndex !== midIndex && minIndex !== midIndex) {
            if (midHeight === height)
                return fontSizes[midIndex];
            else if (midHeight < height) {
                if (maxIndex === (midIndex + 1))
                    return fontSizes[midIndex];
                else {
                    minIndex = midIndex;
                    minHeight = midHeight;
                    midIndex = Math.round((maxIndex + minIndex) * 0.5 + 0.5);
                    divElement.style.fontSize = fontSizes[midIndex] + 'px';
                    rect = divElement.getBoundingClientRect();
                    midHeight = rect.height;
                }
            }
            else {
                if (minIndex === (midIndex - 1)) {
                    return fontSizes[minIndex];
                }
                else {
                    maxIndex = midIndex;
                    maxHeight = midHeight;
                    midIndex = Math.round((maxIndex + minIndex) * 0.5 + 0.5);
                    divElement.style.fontSize = fontSizes[midIndex] + 'px';
                    rect = divElement.getBoundingClientRect();
                    midHeight = rect.height;

                }
            }
        }

        if (maxHeight < height)
            return fontSizes[maxIndex];
        else
            return fontSizes[minIndex];
    }

    const ret: TextLayoutEngine = {
        getMinWidth: getMinWidth,
        getHeightsForColumns: getHeightForColumns,
        getFontSizeForHeight: getFontSizeForHeight
    }
    return ret;

}

export const createMeasureContext = (fontBase: number): MeasureContext | null => {

    const qfs = fontBase * QFONTSZ;
    const amxfs = fontBase * AMXSZ;
    const atxtfs = fontBase * ATXTSZ;

    const cn = document.createElement("canvas").getContext("2d");
    if (cn !== null) {
        cn.font = "regular " + qfs + "px Roboto";
        const spQ = cn.measureText(" ").width;

        cn.font = "regular " + amxfs + "px Roboto";
        const spAMX = cn.measureText(" ").width;

        cn.font = "regular " + atxtfs + "px Roboto";
        const spTXT = cn.measureText(" ").width;

        const ret: MeasureContext = {
            measure: cn,
            questionFontSize: qfs,
            answerMixedFontSize: amxfs,
            answerTextFontSize: atxtfs,
            spaceWidthQuestion: spQ,
            spaceWidthAnswerMixed: spAMX,
            spaceWidthAnswerText: spTXT
        }

        return ret;
    }
    else {
        return null;
    }

}

type WordLayout = {
    maxLineWidth: number;
    maxLineWidthToPenultimateWord: number;
    numberOfLines: number;
}


const layoutWords = (wordMap: WordMap, spaceWidth: number, maxWidth: number): WordLayout => {
    //const ret = Array<number[]>();
    //ret.push(new Array<number>());
    let maxWholeLine = 0;
    let maxToPenultimateWord = 0;
    let lineCount = 0;
    let lineWidth = 0;
    let previousLineWidth = 0;
    var layout = '';

    for (var i = 0; i < wordMap.measures.length; i++) {
        if (lineWidth > 1) {
            const newLineWidth = lineWidth + wordMap.measures[i] + spaceWidth;
            if (newLineWidth < maxWidth) {
                layout += ' ' + wordMap.words[i];
                previousLineWidth = lineWidth;
                lineWidth = newLineWidth;
            }
            else {
                maxWholeLine = Math.max(lineWidth, maxWholeLine);
                maxToPenultimateWord = Math.max(previousLineWidth, maxToPenultimateWord);
                //ret.push(new Array<number>());
                lineCount++;

                //ret[lineIndex].push(words[i]);
                lineWidth = wordMap.measures[i];
                layout += ' || ' + wordMap.words[i];
            }
        }
        else {
            lineWidth = wordMap.measures[i];
            layout += wordMap.words[i];
            //ret[lineIndex].push(words[i]);
        }
    }
    maxWholeLine = Math.max(lineWidth, maxWholeLine);
    maxToPenultimateWord = Math.max(previousLineWidth, maxToPenultimateWord);
    //console.log('Word Layout (' + maxWidth + ', ' + lineCount +') : ' + layout);
    return { maxLineWidth: maxWholeLine, maxLineWidthToPenultimateWord: maxToPenultimateWord, numberOfLines: lineCount + 1 };
}

const createNextTextCoverage = (wordMap: WordMap, spaceWidth: number, lineHeight: number, seed?: WordLayout, maxWidth?: number, text?: string): { coverage: TextCoverage, seed: WordLayout } => {

    const wordMeasures = wordMap.measures;
    if (seed === undefined && maxWidth === undefined) {
        return { coverage: { maxWidth: 0, minWidth: 0, height: 0, lineCount: 0 }, seed: { maxLineWidth: 0, maxLineWidthToPenultimateWord: 0, numberOfLines: 0 } };
    }
    const maxLineWidth = seed !== undefined ? seed.maxLineWidthToPenultimateWord : (maxWidth !== undefined ? maxWidth : 0);
    var previous: WordLayout = { maxLineWidth: 0, maxLineWidthToPenultimateWord: 0, numberOfLines: 0 };

    if (wordMeasures.length === 1) {
        return { coverage: { maxWidth: maxLineWidth, minWidth: wordMeasures[0], height: lineHeight, lineCount: 1 }, seed: previous };
    }
    else if (wordMeasures.length === (seed !== undefined ? seed.numberOfLines + 1 : -1)) {
        const longest = ArrayMax(wordMeasures);
        return { coverage: { maxWidth: maxLineWidth, minWidth: longest, height: wordMeasures.length * lineHeight, lineCount: wordMeasures.length }, seed: previous };

    }



    var current: WordLayout = seed !== undefined ? layoutWords(wordMap, spaceWidth, seed.maxLineWidthToPenultimateWord) : (maxWidth !== undefined ? layoutWords(wordMap, spaceWidth, maxWidth) : { maxLineWidth: 0, maxLineWidthToPenultimateWord: 0, numberOfLines: 0 });
    const retLineCount = seed !== undefined ? seed.numberOfLines + 2 : current.numberOfLines;

    const numberOfLines = current.numberOfLines;
    if (numberOfLines === retLineCount && numberOfLines >= wordMap.measures.length) {
        return { coverage: { maxWidth: maxLineWidth, minWidth: current.maxLineWidth, height: retLineCount * lineHeight, lineCount: retLineCount }, seed: previous };

    }

    var loopCount = 0;
    //console.log('START LOOP ' + (text!==undefined ? '"' + text + '"' : '') + ' :'  + (seed !== undefined ? JSON.stringify(seed) : maxWidth ?? -1000));
    while (current.numberOfLines <= (numberOfLines) && loopCount <= wordMeasures.length) {

        //console.log('createNextTextCoverage while loop current : ' + JSON.stringify(current) + ' nl: ' + numberOfLines + ' lc: ' + loopCount);
        //console.log('createNextTextCoverage while loop previous : ' + JSON.stringify(previous));
        previous = current;
        current = layoutWords(wordMap, spaceWidth, previous.maxLineWidthToPenultimateWord);
        loopCount++;
    }

    if (loopCount > wordMeasures.length) {
        console.log("ERRROR IN LOOP");
    }

    return { coverage: { maxWidth: maxLineWidth, minWidth: previous.maxLineWidth, height: retLineCount * lineHeight, lineCount: retLineCount }, seed: previous };

}

type WordMap = {
    measures: number[];
    longest: number;
    words: string[];
}

const convertStringToWordMap = (text: string, fontBase: number, measureContext: CanvasRenderingContext2D): WordMap => {
    var longestWord = 0;
    measureContext.font = "regular " + fontBase + "px Roboto";
    const txt = text.split(' ');
    const words = txt.map((value: string) => {
        const width = measureContext.measureText(value).width ?? 0;
        longestWord = Math.max(longestWord, width);
        return width;
    });

    return { measures: words, longest: longestWord, words: txt };

}

export const getOuterTextCoverage = (text: string, fontBase: number, lineHeight: number, spaceWidth: number, measureContext: CanvasRenderingContext2D, maxWidth: number): TextCoverage => {
    const ret = new Array<TextCoverage>();
    const wordMap = convertStringToWordMap(text, fontBase, measureContext);
    return (createNextTextCoverage(wordMap, spaceWidth, lineHeight, undefined, maxWidth, text)).coverage;
}


export const getAllTextCoverages = (text: string, fontBase: number, lineHeight: number, spaceWidth: number, measureContext: CanvasRenderingContext2D, maxWidth: number): Array<TextCoverage> => {
    const ret = new Array<TextCoverage>();
    const wordMap = convertStringToWordMap(text, fontBase, measureContext);

    var start = createNextTextCoverage(wordMap, spaceWidth, lineHeight, undefined, maxWidth, text);
    ret.push(start.coverage);
    var seed = start.seed;

    const isValidSeed = () => {
        if (seed.maxLineWidth <= Math.max(wordMap.longest, seed.maxLineWidthToPenultimateWord)) {
            return false;
        }
        var v = false;
        wordMap.measures.forEach((word) => { v = v || (seed.maxLineWidthToPenultimateWord >= word) });
        return v;
    };
    var validSeed = isValidSeed();
    if (validSeed) {
        ret.push({ maxWidth: seed.maxLineWidth, minWidth: Math.max(wordMap.longest, seed.maxLineWidthToPenultimateWord), height: (seed.numberOfLines + 1) * lineHeight, lineCount: seed.numberOfLines + 1 });
    }
    var recheckSeed = false;

    const doCycle = () => { return validSeed && (seed.maxLineWidthToPenultimateWord > wordMap.longest) && (seed.numberOfLines < wordMap.measures.length) };

    while (doCycle()) {
        const res = createNextTextCoverage(wordMap, spaceWidth, lineHeight, seed, undefined, text);
        ret.push(res.coverage);
        seed = res.seed;
        recheckSeed = true;
        validSeed = isValidSeed();
    }

    if (validSeed && recheckSeed) {

        ret.push({ maxWidth: seed.maxLineWidth, minWidth: Math.max(wordMap.longest, seed.maxLineWidthToPenultimateWord), height: (seed.numberOfLines + 1) * lineHeight, lineCount: seed.numberOfLines + 1 });
    }



    return ret;
}


export const getCombinedTextCoverages = (text: string[], fontBase: number, lineHeight: number, spaceWidth: number, measureContext: CanvasRenderingContext2D, maxWidth: number): Array<TextCoverage> => {

    //Place all coverages from all answers into one array but calc min and max line count range for final set. Remember that the smallest lineCount possible will be the largest minimum lineCount across all answers hence max of min
    // max of max the same but less surprising
    var minLineCount = 0;
    var maxLineCount = 0;
    const all = text.map((str) => {
        //get the coverages for one answer
        const coverages = getAllTextCoverages(str, fontBase, lineHeight, spaceWidth, measureContext, maxWidth);
        // establish min and max linecounts across array
        var minLC = Number.MAX_SAFE_INTEGER;
        var maxLC = 0;
        coverages.forEach((cov) => { minLC = Math.min(cov.lineCount, minLC); maxLC = Math.max(cov.lineCount, maxLC) });
        //test to see if largest min or max linecount so far, resulting in across all
        minLineCount = Math.max(minLineCount, minLC);
        maxLineCount = Math.max(maxLC, maxLineCount);

        return coverages;
    }).flat();

    //Create an array of textCpverages organised by lineCounbt. minLincCount maps to element zero.
    const sorted = Array<TextCoverage[]>();
    for (let a = 0; a <= (maxLineCount - minLineCount); a++)
        sorted[a] = Array<TextCoverage>();

    all.forEach((textCoverage) => {
        if (textCoverage.lineCount >= minLineCount && textCoverage.lineCount <= maxLineCount) {
            sorted[textCoverage.lineCount - minLineCount].push(textCoverage);
        }
    });

    //Get the max width for each lineCount. When the width hits this then one answer will hit that linecount which determins the height of all cells in the grid
    const sortedWidths = Array<number>();
    sorted.forEach((textCoverages, index) => {
        var maxWidth = 0;
        const lineCount = index + minLineCount;
        textCoverages.forEach((textCoverage) => { maxWidth = Math.max(maxWidth, textCoverage.minWidth) });
        sortedWidths.push(maxWidth);
    })

    // Starting with the original maxWidth, organise the widths into textCoverages with lineCounts and heights
    const ret = sortedWidths.map((innerWidth, index, all) => {
        const outerWidth = index === 0 ? maxWidth : all[index - 1];
        const textCoverage: TextCoverage = { maxWidth: outerWidth, minWidth: innerWidth, lineCount: index + minLineCount, height: (index + minLineCount) * lineHeight };
        return textCoverage;
    });
    return ret;



}